import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCKTfKa7Hq2aUSchYsfR86zFkRZWvWuAk4",
  authDomain: "coconutoilweb-87f0f.firebaseapp.com",
  projectId: "coconutoilweb-87f0f",
  storageBucket: "coconutoilweb-87f0f.firebasestorage.app",
  messagingSenderId: "941834615073",
  appId: "1:941834615073:web:93ff456668c2bcbb246660",
  measurementId: "G-GL1D9BFKLC",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
// Super admin hardcoded เพื่อกัน lockout — admin คนอื่นถูกจัดการผ่าน Firestore collection `admins/{email}`
export const SUPER_ADMIN_EMAIL = "thaicoconut.org@gmail.com";
export default app;
